export enum positionStatusEnum {
    WAIT_FOR_VALIDATION = 'wait-for-validation',
    VALIDATED = 'validated',
  }